import { connect } from 'react-redux'
import OrderForm from '../components/OrderForm'

function mapStateToProps(state) {

    const { glass_height_correction,
        glass_width_correction,
        glass_height_correction_window,
        glass_width_correction_window,
        window_height_correction,
        window_width_correction} = state.corrections

    return {
        rows: state.rows,
        glass_height_correction,
        glass_width_correction_window,
        glass_width_correction,
        glass_height_correction_window,
        window_height_correction,
        window_width_correction
    }
}

function mapDispatchToProps(dispatch) {
    return {
        onSubmit: () => dispatch({type: 'ORDER_FORM_SUBMITTED'}),
        onRowChange: (index, name, value) => dispatch({type: 'ORDER_FORM_CHANGED', value, name,index}),
        onCorrectionChange: (name, value) => dispatch({type: 'CORRECTIONS_CHANGED', name, value}),
        addRow: () => dispatch({type: 'ADD_ROW'})
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(OrderForm)


// WEBPACK FOOTER //
// ./src/containers/OrderForm.js